import React from 'react'
import './MenuButton.scss'
import clsx from 'clsx'

export type TPropsMenuButton = {
  size?: 'large' | 'medium' | 'small'
  icon?: string
  active?: boolean
}

function MenuButton(props: TPropsMenuButton & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { active = false, icon, children, ...rest } = props
  return (
    <button type="button" className={clsx('tq-menu-button', { active })} {...rest}>
      <div className="content">
        {icon && <i className={icon} />}
        {children}
      </div>
    </button>
  )
}

export default MenuButton
